/** Sesli asistan kimliği (harici sağlayıcı) */
export const ELEVENLABS_AGENT = {
  name: 'Otomotiv Servis Randevu Asistanı',
  shortName: 'Dijital Randevu Asistanı',
  id:
    process.env.REACT_APP_ELEVENLABS_AGENT_ID ||
    'agent_8101ks3gqxk4ew8asewe2nvxs477',
};

export const DEFAULT_CONNECTION_TYPE = 'webrtc';
